module.exports = __webpack_public_path__ + "img/1-1.395ebf94.svg";